<template>
  <div class="wrapper">
    <side-bar :sidebar-links="$sidebar.sidebarLinks">

    </side-bar>
    <div class="main-panel" style="position: relative;">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import { loadChatbot } from '../../../utils/chatbotLoader';
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    },
    mounted() {
      loadChatbot();
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue